import { ReactNode, Suspense, useEffect } from 'react';
import styled from 'styled-components';
import LoadingIndicator from './LoadingIndicator';

const Wrapper = styled.div`
  min-height: 100vh;
  overflow-y: auto;
  background-color: var(--color-gray-white);
`;

const Header = styled.header`
  background-color: var(--color-increase-dark);
  color: var(--color-gray-white);
  padding: 72px 0 48px;
`;

const Title = styled.h1`
  ${({ theme }) => theme.typography.superHeader};
  max-width: 707px;
  margin: 0 auto;
  padding: 0 24px;
`;

const Content = styled.main`
  ${({ theme }) => theme.typography.body};
  color: var(--color-gray-blackLight);
  max-width: 707px;
  margin: 0 auto;
  padding: 40px 24px 80px;

  h2,
  h3,
  h4 {
    ${({ theme }) => theme.typography.H2};
    color: var(--color-gray-black);
    font-weight: 700;
    margin: 40px 0 16px;
  }

  h3,
  h4 {
    ${({ theme }) => theme.typography.H3};
  }

  h2:first-child {
    margin-top: 0;
  }

  p {
    margin: 0 0 12px;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 24px;
  }

  li {
    margin-bottom: 6px;
  }

  a {
    color: var(--color-primaryAction-dark);
    text-decoration: underline;
  }

  strong {
    color: var(--color-gray-black);
  }
`;

interface LegalPageProps {
  title: string;
  children: ReactNode;
}

export function LegalPage({ title, children }: LegalPageProps) {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = 'Click de Pago';
    };
  }, [title]);

  return (
    <Wrapper>
      <Header>
        <Title>{title}</Title>
      </Header>
      <Content>
        <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
      </Content>
    </Wrapper>
  );
}
